//-------------MONITORING_COPY--------------
import {useDispatch, useSelector} from "react-redux";
import {
    selectedDatasourceTypesIdsSelectorMonitoring,
    setSelectedDatasourceTypesIdsMonitoring
} from "../Selectors/filtersSliceMonitoring";
import React from "react";

export const useSelectedDatasourceTypesIdsMonitoring = () => {
    const dispatch = useDispatch();
    const datasourceTypesIds = useSelector(selectedDatasourceTypesIdsSelectorMonitoring);

    const onChangeDatasourceTypesIds = React.useCallback((ids: number[] | undefined) => {
        dispatch(setSelectedDatasourceTypesIdsMonitoring(ids));
    }, [dispatch]);
    return {
        datasourceTypesIds,
        onChangeDatasourceTypesIds,
    };
};